import styled from "../../../__compat__/styled-components/main.entry.mjs.mjs";
export const StyledTrayContainer = styled.div.withConfig({ displayName: "auir-611444a-StyledTrayContainer", componentId: "auir-611444a-10zwyt4" }) `
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  overflow: hidden;
`;
export const StyledTray = styled.div.withConfig({ displayName: "auir-611444a-StyledTray", componentId: "auir-611444a-7vpn5t" }) `
  display: flex;
  flex-direction: column;

  width: 100%;
  max-height: 100%;

  background-color: var(${(props) => props.theme.colors.background.level[2]});
  transform: ${(props) => (props.open ? 'none' : 'translateY(100%)')};

  transition-timing-function: var(${(props) => props.theme.easing});
  transition-duration: ${(props) => `${props.transitionDuration}ms`};
  transition-property: transform;
`;
//# sourceMappingURL=Tray.styles.mjs.mjs.map